import React from "react";

const StepIcon: React.FC = ({ children }) => (
  <div className={"step-icon"}>{children}</div>
);

export default StepIcon;
